module.exports = __webpack_public_path__ + "static/media/ICON_FB_ACTIVE.95aa2ecf.svg";